// src/analysis/deteccionMaleza/deteccionMalezaFetchIndicators.jsx

import { API_BASE_URL_DASHBOARD } from "../../utils/config";

export const fetchDataDeteccionMalezaIndicators = async (
    startDate,
    endDate,
    endpoint,
    idUsuario,
    minMaxParams = {},
    filters = {},
    { signal } = {}
) => {
    try {
        const queryParams = new URLSearchParams({
            userId: idUsuario,
            FECHA_INICIO: startDate,
            FECHA_FINAL: endDate,
            minMax: JSON.stringify(minMaxParams),
            NOMBRE_FINCA: filters.fincaDM || '',
            ZAFRA: filters.zafraDM || '',
            TERCIO: filters.tercioDM || '',
            FILTER_USER_IDS: filters.FILTER_USER_IDS || '',
        }).toString();

        const response = await fetch(
            `${API_BASE_URL_DASHBOARD}api/indicators/deteccion-maleza/${endpoint}?${queryParams}`,
            { signal }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        return data.map(item => {
            const indicadores = {
                _id: item._id || null
            };

            Object.keys(item).forEach(key => {
                const indicador = item[key];

                if (indicador && typeof indicador === 'object' && 'valor' in indicador && 'titulo' in indicador) {
                    indicadores[key] = {
                        title: indicador.titulo,
                        value: indicador.valor
                    };
                }
            });

            return indicadores;
        });
    } catch (error) {
        console.error(`Error al obtener los indicadores de detección de maleza (${endpoint}):`, error);
        return [];
    }
};

export const initialIndicatorsDeteccionMaleza = {
    cardData: {
        totalAreaMaleza: { title: 'Total Área con Maleza', max: '', min: '' },
        totalAreaPoligono: { title: 'Total Área Analizada', max: '', min: '' },
        totalPercentageMaleza: { title: 'Total % de Maleza', max: '', min: '' },
        totalUsd: { title: 'Total de USD', max: '', min: '' },
    },
    chartData: {
        totalAreaMalezaPorFinca: { title: 'Áreas por Finca', data: [] },
        totalPercentageMalezaPorFinca: { title: 'Porcentajes por Finca', data: [] },
        totalAreaMalezaPorZafra: { title: 'Áreas por Zafra', data: [] },
        totalAreaMalezaPorTercio: { title: 'Áreas por Tercio', data: [] },
    }
};
